import React, { useState } from "react";
import { Button, ButtonProps } from "@amzn/awsui-components-react";

interface CopyToClipboardProps {
  getContent: () => Promise<string>;
  children?: string;
  disabled?: boolean;
  iconName?: ButtonProps["iconName"];
  variant?: ButtonProps["variant"];
  ariaLabel?: string;
}

export const CopyToClipboard: React.FC<CopyToClipboardProps> = ({
  getContent,
  children,
  disabled = false,
  iconName,
  variant,
  ariaLabel,
}) => {
  const [showCopied, setShowCopied] = useState(false);

  const handleClick = async () => {
    try {
      const content = await getContent();
      await navigator.clipboard.writeText(content);
      setShowCopied(true);
      setTimeout(() => setShowCopied(false), 3000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <Button
        onClick={handleClick}
        disabled={disabled}
        iconName={iconName}
        variant={variant}
        ariaLabel={ariaLabel}
      >
        {children}
      </Button>
      {showCopied && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            marginTop: "4px",
            right: "0",
            backgroundColor: "#0972d3",
            color: "white",
            padding: "4px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            whiteSpace: "nowrap",
            zIndex: 1000,
          }}
        >
          Copied to clipboard
        </div>
      )}
    </div>
  );
};
